<script>
import { mapActions, mapState } from 'vuex';
import {
    UI_MAP_READY,
    UI_MAP_LOADED,
    UI_STEP_SELECTED,
    MAP_OBJECT_HOVERED,
    MAP_SHOW_PATH_STEPS,
    MAP_OBJECT_SELECTED
} from "../../../shared/components/map-viewer/constants/map-events";

import {
    SUCCESS_SEARCH,
    UNSUCCESS_SEARCH,
    NO_DIRECT_MATCHES,
    SEARCH_DATA_CHANGE,
    CHECK_SEARCH_VALUE,
    ERASE_SEARCH_STRING,
} from '../../../utils/constants/bus-events-constants'

export default {
    name: "OStatisticsController",

    data() {
        return {
            mapStartLoadingTime: 0,
            searchData: {}
        }
    },
    computed: {
        ...mapState([
            'sessionId',
            'activePath'
        ])
    },
    methods: {
        ...mapActions([
            "sendEvent",
            "sendGuideEvent",
            "sendSearchEvent",
            "sendGuideStepEvent",
            "sendObjectClickEvent",
            "sendObjectHoverEvent",
            "sendCategoryClickEvent"
        ]),
        onMapReady() {
            const mapLoadingTime = new Date().getTime() - this.mapStartLoadingTime
            const event = {
                event_category: 'map',
                event: 'loading-time',
                target_id: mapLoadingTime

            }
            this.sendEvent(event)
            this.$bus.$off(UI_MAP_READY, this.onMapReady);
        },
        onMapLoaded(){
            this.mapStartLoadingTime = new Date().getTime()
        },
        sendUIGuideStepEvent (stepIndex) {
            this.sendGuideStepEvent({stepIndex, eventCategory: 'ui'})
        },
        sendMapGuideStepEvent (stepIndex) {
            this.sendGuideStepEvent({stepIndex, eventCategory: 'map'})
        },
        searchDataChange(newData) {
            this.searchData = newData
        },
        sendEraseSearchStringEvent(data) {
            this.sendSearchEvent(data)
        },
        sendUnsuccessSearchEvent() {
            this.sendSearchEvent({
                value1: this.searchData.searchValue || this.searchData.oldValue,
                value2: "not_found",
                value3: "leave",
                target_id: this.searchData.searchResultsCount
            })
        },
        sendSuccessSearchEvent(data) {
            this.sendSearchEvent(data)
        },
        getRouteQuery() {
            if(
                this.$route.query['redirect-from']
                && (this.$route.query['redirect-from'] === 'sms' || this.$route.query['redirect-from'] === 'qr')
            ) {
                return this.$route.query['redirect-from']
            } else {
                return false
            }
        },
        checkSearchValue() {
            this.searchData.searchValue && this.sendUnsuccessSearchEvent()
        },
        noDirectMatches() {
            this.sendSearchEvent({
                value1: this.searchData.searchValue || this.searchData.oldValue,
                value2: "not_found",
                value3: 'no_direct_matches',
                target_id: this.searchData.searchResultsCount
            })
        }
    },
    watch:{
        //activePath: 'sendGuideEvent'
        activePath(activePath, oldActivePath){
            if(
                activePath && !_.isEqual(activePath, oldActivePath)
            ) {
                const routeQuery = this.getRouteQuery();
                if (routeQuery) {
                    this.sendGuideEvent({
                        guide: this.activePath,
                        params: {
                            cid: 2,
                            event: "guide",
                            event_category: routeQuery,
                        }
                    })
                } else {
                    this.sendGuideEvent({
                        guide: activePath,
                        params: {
                            event: "guide",
                            event_category: "ui",
                        }
                    })
                }
            }
        },
        '$route'(newRoute, oldRoute) {
            if(
                this.searchData.searchValue
                && oldRoute.name === 'terminal.search'
                && newRoute.name !== 'terminal.guide'
                && newRoute.name !== 'terminal.service'
            ) {
                this.sendUnsuccessSearchEvent()
            } else if (
                this.searchData.searchValue
                && oldRoute.name === 'mobile.searchbar'
                && newRoute.name !== 'mobile.guide'
                && newRoute.name !== 'mobile.service'

            ) {
                this.sendUnsuccessSearchEvent()
            }
        }
    },
    created(){
        this.$bus.$on(UI_MAP_READY, this.onMapReady);
        this.$bus.$on(UI_MAP_LOADED, this.onMapLoaded);
        this.$bus.$on(UI_STEP_SELECTED, this.sendUIGuideStepEvent);

        this.$bus.$on(MAP_OBJECT_HOVERED, this.sendObjectHoverEvent);
        this.$bus.$on(MAP_OBJECT_SELECTED, this.sendObjectClickEvent);
        this.$bus.$on(MAP_SHOW_PATH_STEPS, this.sendMapGuideStepEvent);

        this.$bus.$on(NO_DIRECT_MATCHES, this.noDirectMatches);
        this.$bus.$on(SEARCH_DATA_CHANGE, this.searchDataChange);
        this.$bus.$on(CHECK_SEARCH_VALUE, this.checkSearchValue);
        this.$bus.$on(SUCCESS_SEARCH, this.sendSuccessSearchEvent);
        this.$bus.$on(UNSUCCESS_SEARCH, this.sendUnsuccessSearchEvent);
        this.$bus.$on(ERASE_SEARCH_STRING, this.sendEraseSearchStringEvent);
    },
    beforeDestroy(){
        this.$bus.$off(UI_MAP_READY, this.onMapReady);
        this.$bus.$off(UI_MAP_LOADED, this.onMapReady);
        this.$bus.$off(UI_STEP_SELECTED, this.sendUIGuideStepEvent);

        this.$bus.$off(MAP_OBJECT_HOVERED, this.sendObjectHoverEvent);
        this.$bus.$off(MAP_OBJECT_SELECTED, this.sendObjectClickEvent);
        this.$bus.$off(MAP_SHOW_PATH_STEPS, this.sendMapGuideStepEvent);

        this.$bus.$off(NO_DIRECT_MATCHES, this.noDirectMatches);
        this.$bus.$off(SEARCH_DATA_CHANGE, this.searchDataChange);
        this.$bus.$off(CHECK_SEARCH_VALUE, this.checkSearchValue);
        this.$bus.$off(SUCCESS_SEARCH, this.sendSuccessSearchEvent);
        this.$bus.$off(UNSUCCESS_SEARCH, this.sendUnsuccessSearchEvent);
        this.$bus.$off(ERASE_SEARCH_STRING, this.sendEraseSearchStringEvent);
    },
    render(){ return null }
}
</script>
